<template>
  <div class="address-entry-detail-modal" :class="editStateClass">
    <modal-frame :showModalFlag="modalDisplay" :position="'fullscreen'" :additionalClass="editStateClass">
      <div class="modal-header" :class="editStateClass">
        <span class="back-button" @click="closeModal">＜ {{ returnLinkName }}</span>
      </div>
      <div class="modal-body" :class="editStateClass" v-if="addressEntry">
        <div class="portrate-column">
          <user-portrate :target="addressEntry" displaySize="large"/>
        </div>
        <div class="name-column">{{ addressEntry.name }}</div>
        <div class="description-column" v-html="descriptionHTML"></div>
        <div class="memo-column" v-if="!memoEditing">
          <span class="memo-controll-label">メモ<button class="memo-edit-btn" @click="editMemo">編集</button></span>
          <div class="memo-display" v-html="memoHTML"></div>
        </div>
        <div class="memo-column" v-if="memoEditing">
          <span class="memo-controll-label">メモ<button class="memo-update-btn" @click="updateMemo">保存</button></span>
          <textarea v-model="memo"></textarea>
        </div>
        <div class="narrativebook-column">
          <h2>ナラティブブック</h2>
          <div class="label-value-column" v-if="!addressEntry.organization_id">
            <div class="label">NBID</div>
            <div class="value" v-if="addressEntry.nb_id">{{ addressEntry.nb_id }}</div>
            <div class="value" v-if="!addressEntry.nb_id">連携なし</div>
          </div>
          <div class="label-value-column" v-if="addressEntry.organization_id">
            <div class="label">種別</div>
            <div class="value">施設代表アカウント</div>
          </div>
          <div class="action-column" v-if="!addressEntry.organization_id && addressEntry.nb_id">
            <a @click="accessNarrativeBook">
              ナラティブブックを開く
              <img src="/images/outer_link_icon.svg" />
            </a>
          </div>
        </div>
        <div class="other-column">
          <div class="label-value-column">
            <div class="label">お気に入り</div>
            <div class="value" @click="toggleFavourite">
              <img src="/images/user_favourite_on.svg" class="favourite-icon" :class="{disable: memoEditing}" v-show="favourite"/>
              <img src="/images/user_favourite_off.svg" class="favourite-icon" :class="{disable: memoEditing}" v-show="!favourite"/>
            </div>
          </div>
          <div class="label-value-column group">
            <div class="label">グループ</div>
            <div class="value">
              <div class="group-name">{{ addressCategory.name }}</div>
            </div>
          </div>
          <div class="group-controll">
            <button class="change-category-btn" :class="{disable: memoEditing}" @click="prepareMoveCategory" v-if="addressBook.length > 1">グループ変更</button>
            <button class="change-category-btn" :class="{disable: memoEditing}" @click="prepareCloneCategory" v-if="addressBook.length > 1">グループへコピー</button>
            <button class="change-category-btn" :class="{disable: memoEditing}" @click="removeEntry">削除</button>
          </div>
        </div>
        <div class="call-controll" :class="{disable: memoEditing}">
          <img src="/images/prepare_call_icon.svg" @click="prepareCall"/>
          <div class="label">通話準備</div>
        </div>
      </div>
    </modal-frame>
    <select-address-category-modal
      :modalDisplay="selectCategoryDisplay"
      :currentCategory="addressCategory"
      :disableCategories="disableCategories"
      :disableCheckMarker="disableCheck"
      v-on:categorySelectedEvent="categorySelected"
      v-on:closeModalEvent="closeSelectCategory"
      />
    <confirm-dialog
      :showDialog="confirmDialogVisible"
      :title="confirmDialogTitle"
      :message="confirmDialogMessage"
      :dialogType="confirmDialogType"
      v-on:negativeResultEvent="confirmFinishNegative"
      v-on:positiveResultEvent="confirmFinishPositive"
      />
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

import UserPortrate from '@/components/appView/common/UserPortrate.vue'
import SelectAddressCategoryModal from '@/components/appView/common/SelectAddressCategoryModal.vue'
import ModalFrame from '@/components/common/ModalFrame.vue'
import ConfirmDialog from '@/components/common/ConfirmDialog.vue'

import ConfirmDialogControll from '@/mixin/ConfirmDialogControll'

import * as DIALOG_TYPE from '@/assets/constants/dialogType.js'

export default {
  mixins: [ConfirmDialogControll],

  name: 'AddressEntryDetailModal',

  components: {
    UserPortrate,
    SelectAddressCategoryModal,
    ModalFrame,
    ConfirmDialog,
  },

  props: {
    addressEntryID: Number,
    modalDisplay: Boolean,
    returnLinkName: String,
  },

  emits: [
    'closeModalEvent',
    'prepareCallEvent',
  ],

  data () {
    return {
      addressEntry: null,
      addressCategory: null,
      disableCategories: [],
      disableCheck: false,
      selectCategoryDisplay: false,
      cloneEntry: false,
      memoEditing: false,
      memo: '',
      favourite: false,
    }
  },

  // mounted () {
  //   this.loadEntry()
  // },

  watch: {
    modalDisplay: { handler: 'loadEntry', immediate: true },
    addressEntry: { deep: true, handler: 'initDatas', immediate: true },
  },

  computed: {
    ...mapState({
      addressBook: state => state.addressBook.addressCategories,
      currentUser: state => state.user.currentUser,
    }),

    ...mapGetters({
      fetchEntryWithCategory: 'addressBook/fetchEntryWithCategory',
      notIncludedCategories: 'addressBook/notIncludedCategories',
    }),

    editStateClass () {
      if (this.memoEditing) {
        return 'editing'
      } else {
        return ''
      }
    },

    descriptionHTML () {
      if (this.addressEntry.description) {
        return this.addressEntry.description.replace(/\n/gi, '<br />')
      }
      return ''
    },

    memoHTML () {
      if (this.memo) {
        return this.memo.replace(/\n/gi, '<br />')
      }
      return ''
    },

    categorySelectionAvailable () {
      if (this.addressBook.length > 1) {
        return true
      }
      return false
    },

    narrativeAccessURL () {
      return process.env.VUE_APP_NARRATIVEBOOK_HOST
    },

    // uerPortrate () {
    //   if (this.addressEntry.icon_image_path) {
    //     return '<img src="' + this.addressEntry.icon_image_path + '" class="icon-image" />'
    //   } else {
    //     return '<span class="generated-icon-image">' + this.addressEntry.name.charAt(0) + '</span>'
    //   }
    // },
  },

  methods: {
    ...mapActions({
      fetchAddressBook: 'addressBook/fetch',
      createEntry: 'addressBook/createEntry',
      updateEntry: 'addressBook/updateEntry',
      destroyEntry: 'addressBook/destroyEntry',
    }),

    async loadEntry (force) {
      console.log('load entry')
      try {
        if (this.addressBook.length <= 0 || force) {
          console.log('load entry fetch')
          await this.fetchAddressBook()
        }
        if (this.addressEntryID) {
          console.log('get address entry...')
          let entWithCate = await this.fetchEntryWithCategory(this.addressEntryID)
          this.addressEntry = entWithCate.address_entry
          this.addressCategory = entWithCate.address_category
          console.log(this.addressEntry)
          this.initDatas()
        } else {
          this.addressEntry = null
        }
      } catch (error) {
        console.error(error)
        this.addressEntry = null
        this.showNotifyDialog("データ取得の失敗", 'データの取得に失敗しました。')
      }
    },

    initDatas () {
      console.log('call init data')
      if (this.addressEntry) {
        console.log(this.addressEntry)
        this.memo = this.addressEntry.memo
        this.favourite = this.addressEntry.favourite
        this.addressCategory = this.addressBook.find((cate) => cate.id === this.addressEntry.address_category_id)
      } else {
        this.memo = ''
        this.favourite = false
      }
      this.memoEditing = false
      console.log('init end memo: ' + this.memo)
    },

    editMemo () {
      this.memoEditing = true
    },

    updateMemo () {
      if (this.addressEntry) {
        let formData = new FormData()
        formData.append('id', this.addressEntry.id)
        formData.append('address_category_id', this.addressEntry.address_category_id)
        formData.append('memo', this.memo)
        this.updateEntry(formData).then(res => {
          this.addressEntry = res.data.address_entry
          this.initDatas()
          this.memoEditing = false
        }).catch(error => {
          console.log(error)
          this.showNotifyDialog("データ更新の失敗", 'データの更新に失敗しました。')
        })
      }
    },

    accessNarrativeBook () {
      if (!this.memoEditing) {
        window.open(this.narrativeAccessURL, '_blank')
      }
    },

    toggleFavourite () {
      console.log('toggle favourite')
      if (!this.memoEditing) {
        let changedFavourite = !this.favourite
        // this.favourite = !this.favourite
        if (this.addressEntry) {
          let formData = new FormData()
          formData.append('id', this.addressEntry.id)
          formData.append('address_category_id', this.addressEntry.address_category_id)
          formData.append('memo', this.memo ?? '')
          if (changedFavourite) {
          // if (this.favourite) {
            formData.append('favourite', true)
          }
          this.updateEntry(formData).then(async () => {
            await this.loadEntry(true)
            this.favourite = changedFavourite
          }).catch(error => {
            console.log(error)
            this.showNotifyDialog("データ更新の失敗", 'データの更新に失敗しました。')
          })
        }
      }
    },

    prepareMoveCategory () {
      if (!this.memoEditing) {
        this.disableCategories = this.notIncludedCategories( this.addressEntry.narrative_phone_id)
        this.cloneEntry = false
        this.disableCheck = false
        this.selectCategoryDisplay = true
      }
    },

    prepareCloneCategory () {
      if (!this.memoEditing) {
        this.disableCategories = this.notIncludedCategories( this.addressEntry.narrative_phone_id)
        this.disableCheck = true
        this.cloneEntry = true
        this.selectCategoryDisplay = true
      }
    },

    categorySelected (category) {
      if (!this.memoEditing) {
        if (this.cloneEntry) {
          console.log('gonna clone entry....')
          let formData = new FormData()
          formData.append('narrative_phone_id', this.addressEntry.narrative_phone_id)
          formData.append('address_category_id', category.id)
          this.createEntry(formData).then(() => {
            this.selectCategoryDisplay = false
            this.showMessageDialog("連絡先のコピー", '連絡先[' + this.addressEntry.name + ']をグループ[' + category.name + ']にコピーしました。')
          }).catch(error => {
            console.log(error)
            this.selectCategoryDisplay = false
            this.showNotifyDialog("連絡先のコピーの失敗", '連絡先のコピーに失敗しました。')
          })
        } else {
          console.log('gonna move entry....')
          let formData = new FormData()
          formData.append('id', this.addressEntry.id)
          formData.append('address_category_id', category.id)
          formData.append('memo', this.memo)
          if (this.addressEntry.favourite) {
            formData.append('favourite', true)
          }
          this.updateEntry(formData).then(() => {
            // this.loadEntry(true)
            this.addressCategory = category
            this.selectCategoryDisplay = false
            this.showMessageDialog("連絡先グループ変更", '連絡先[' + this.addressEntry.name + ']をグループ[' + category.name + ']に移動しました。')
          }).catch(error => {
            console.log(error)
            this.selectCategoryDisplay = false
            this.showNotifyDialog("連絡先グループ変更", '連絡先グループ変更に失敗しました。')
          })
        }
      }
    },

    closeSelectCategory () {
      this.selectCategoryDisplay = false
    },

    removeEntry () {
      if (!this.memoEditing) {
        this.showConfirmDialog(
          '連絡先の削除', 
          '連絡先[' + this.addressEntry.name + ']をグループ[' + this.addressCategory.name + ']から削除します。\nよろしいですか？',
          DIALOG_TYPE.EXECUTE, 
          () => { this.executeRemoveEntry() }
        )
      }
    },

    executeRemoveEntry () {
      // remove entry from group
      this.destroyEntry(this.addressEntryID).then(res => {
        console.log(res)
        this.showNotifyDialog('連絡先の削除', '連絡先[' + this.addressEntry.name + ']をグループ[' + this.addressCategory.name + ']から削除しました。')
        this.$emit('closeModalEvent')
      }).catch(error => {
        console.log(error)
        this.showNotifyDialog("連絡先削除の失敗", '連絡先の削除に失敗しました。')
      })
    },

    closeModal () {
      if (!this.memoEditing) {
        this.$emit('closeModalEvent')
      }
    },

    prepareCall () {
      if (!this.memoEditing) {
        console.log('prepareCall, ' + this.currentUser.account_name + '/' + this.addressEntry)
        this.$emit('prepareCallEvent', this.currentUser.account_name, [this.addressEntry])
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/css/global.scss';
@import '@/assets/css/mediaQuery.scss';
@import '@/assets/css/colorTable.scss';

.address-entry-detail-modal {
  margin: 0;
  &.editing {
    background-color: #ddd;
  }
  .modal-header {
    height: 20px;
    padding: 10px;
    .back-button {
      color: $global-link-color;
      font-size: 20px;
    }
    &.editing {
      background-color: #ddd;
    }
  }
  .modal-body {
    height: calc(100% - 42px);
    &.editing {
      background-color: #ddd;
    }
    .portrate-column {
      margin: 0 auto;
      text-align: center;
    }
    .name-column {
      margin-top: 20px;
      font-size: 26pt;
      text-align: center;
    }
    .description-column {
      margin-top: 5px;
      font-size: 10pt;
      text-align: center;
    }
    .memo-column {
      margin: 10px 30px 0;
      .memo-controll-label {
        display: block;
        font-size: 10pt;
        .memo-edit-btn {
          margin: 5px 10px;
          padding: 3px 10px;
          border-radius: 5px;
          border: 1px solid $normal-btn-color;
          background-color: $normal-btn-color;
          color: #fff;
          font-size: 10pt;
        }
        .memo-update-btn {
          margin: 5px 10px;
          padding: 3px 10px;
          border-radius: 5px;
          border: 1px solid $phone-main-color;
          background-color: $phone-main-color;
          color: #fff;
          font-size: 10pt;
        }
      }
      .memo-display {
        margin: 5px 0;
        padding: 5px;
        width: calc(100% - 10px);
        height: 100px;
        border-radius: 5px;
        border: 1px solid #999;
        font-size: 16pt;
        color: #666;
      }
      textarea {
        margin: 5px 0;
        padding: 5px;
        width: calc(100% - 10px);
        height: 100px;
        border-radius: 5px;
        border: 1px solid #999;
        font-size: 16pt;
        color: #666;
      }
    }
    .narrativebook-column  {
      margin: 0 30px;
      padding: 10px 0;
      border-top: 1px solid #ddd;
      h2 {
        margin: 0;
        font-size: 14pt;
      }
      .label-value-column {
        margin: 10px 0;
        display: flex;
        align-items: center;
        .label {
          margin-right: 10px;
          width: 30%;
          min-width: 30%;
          text-align: right;
          font-size: 12pt;
        }
        .value {
          font-size: 13pt;
          img {
            width: 30px;
            height: 30px;
            &.disable {
              opacity: 0.5;
            }
          }
        }
      }
      .action-column {
        text-align: right;
        a {
          color: #666;
          border-bottom: 1px solid #666;
          font-size: 13pt;
          text-decoration: none;
          img {
            height: 12pt;
          }
        }
      }
    }
    .other-column {
      margin: 0 30px;
      padding: 10px 0;
      border-top: 1px solid #ddd;
      .label-value-column {
        margin-bottom: 10px;
        display: flex;
        align-items: center;
        &.group {
          align-items: flex-start;
          .label {
            padding-top: 3px;
          }
        }
        .label {
          margin-right: 10px;
          width: 30%;
          min-width: 30%;
          text-align: right;
          font-size: 12pt;
        }
        .value {
          font-size: 13pt;
          width: calc(70% - 10px);
          min-width: calc(70% - 10px);
          img {
            width: 30px;
            height: 30px;
          }
        }
      }
      .group-controll {
        display: flex;
        justify-content: space-between;
        button {
          margin: 5px 0;
          padding: 3px 5px;
          border-radius: 5px;
          border: 1px solid $normal-btn-color;
          background-color: $normal-btn-color;
          color: #fff;
          font-weight: bold;
          font-size: 12pt;
          &.disable {
            color: #aaa;
          }
        }
      }
    }
    .call-controll {
      text-align: center;
      img {
        width: 60px;
        height: 60px;
      }
      .label {
        margin-top: 10px;
        font-size: 10pt;
      }
      &.disable {
        img {
          opacity: 0.5;
        }
      }
    }
  }
}
</style>